<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 5640 5640"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle class="fil0" cx="2820" cy="2820" r="2820" />
   <g id="_794550376">
   <path class="fil1"
         d="M4030 2902c160,-19 288,92 305,232 20,163 -96,290 -235,307 -159,19 -287,-96 -304,-234 -20,-160 95,-289 234,-305zm-564 -907c162,-39 295,84 320,212 33,163 -83,294 -211,320 -341,69 -475,-444 -109,-532zm754 181c80,-27 149,58 106,131 -19,30 -106,110 -135,139 -90,90 -785,799 -824,811 -80,26 -148,-58 -108,-130 21,-40 602,-610 678,-686 47,-47 236,-249 283,-265zm-473 1632c158,0 273,-8 418,-65 205,-79 366,-192 499,-370 44,-58 89,-124 119,-194 112,-261 143,-511 50,-787 -89,-267 -244,-475 -408,-694l-474 -633c-63,-101 -82,-166 -164,-166 -66,0 -105,89 -150,162 -64,104 -339,465 -437,586 -169,207 -365,498 -447,741 -84,253 -68,478 22,728 49,138 181,325 292,418 120,101 204,151 349,208 20,8 40,14 59,20 67,22 186,46 272,46z" />
     <path class="fil0"
           d="M4220 2176c-47,16 -236,218 -283,265 -76,76 -657,646 -678,686 -40,72 28,156 108,130 39,-12 734,-721 824,-811 29,-29 116,-109 135,-139 43,-73 -26,-158 -106,-131z" />
     <path class="fil0"
           d="M3431 2280c-24,-127 162,-150 178,-33 17,121 -159,136 -178,33zm35 -285c-366,88 -232,601 109,532 128,-26 244,-157 211,-320 -25,-128 -158,-251 -320,-212z" />
     <path class="fil0"
           d="M4042 3084c120,-35 154,148 48,175 -116,29 -164,-141 -48,-175zm-12 -182c-139,16 -254,145 -234,305 17,138 145,253 304,234 139,-17 255,-144 235,-307 -17,-140 -145,-251 -305,-232z" />
     <path class="fil1" d="M3431 2280c19,103 195,88 178,-33 -16,-117 -202,-94 -178,33z" />
     <path class="fil1" d="M4042 3084c-116,34 -68,204 48,175 106,-27 72,-210 -48,-175z" />
  </g>
   <path class="fil2"
         d="M1972 3517l0 -1988c0,-102 -87,-186 -183,-186 -95,0 -182,84 -182,186l0 2007c-249,89 -428,326 -428,606 0,355 288,643 644,643 355,0 643,-288 643,-643 0,-304 -211,-558 -494,-625z" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'ThermoHumidityMeter',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}

.fil2 {
  fill: #FEFEFE;
  fill-rule: nonzero
}
</style>
